
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { IModalComponent, FormButtonDisabler, Validations, DropdownField, Btn, Field, TextField } from '@samc/centricity-core';
  import { IPackageDocumentRequest, IPackageDocumentSetting } from './../Interfaces';
  import { DocumentTypeSource } from '@/Sources';
  import { AjaxHelper } from '@samc/common';
  import { PackageDocumentValidator } from '@/Validators';

  @Component({
    name: 'add-document-modal',
    components: { FormButtonDisabler, Btn, Field, DropdownField, TextField }
  })
  export default class AddDocumentModalComponent extends Vue implements IModalComponent {
    @Prop() public addCloseProp!: (callback: () => Promise<boolean | undefined>) => void;
    @Prop() public closeProp!: () => void;
    @Prop() public id!: string;
    @Prop() public verificationToken!: string;
    @Prop() public addedDocumentId!: string;
    @Prop() public viewName!: string;
    @Prop() public packageDocumentSetting!: IPackageDocumentSetting;
    @Prop({ required: true }) public packageType!: 'buy' | 'sell';

    public documentTypeSource = new DocumentTypeSource(true);
    public isLoaded: boolean = false;
    public addResult: boolean = false;
    public showValidations: boolean = false;
    public isCancelled: boolean = false;
    public validator = new PackageDocumentValidator(true);

    public updatePackageDocument: IPackageDocumentRequest = {
      packageDocumentTypeId: null,
      packageId: this.packageDocumentSetting?.packageId,
      documentName: this.viewName,
      documentTag: null,
      id: this.addedDocumentId
    } as any;

    public get validations(): Validations<IPackageDocumentRequest> {
      return this.validator.isValid(this.updatePackageDocument);
    }
    
    public async mounted() {
      const fileName = this.viewName;
      const documentId = this.addedDocumentId;
      this.verificationToken ??= await this.$verificationToken();
      this.updatePackageDocument = {
        documentName: fileName,
        documentTag: null,
        packageId: this.packageDocumentSetting.packageId,
        id: documentId,
        modifiedBy: $user ? $user?.name : '',
        createdBy: $user ? $user?.name : '',
        internalId: null,
        packageDocumentTypeId: null
      };


      this.isLoaded = true;

      this.addCloseProp(async () => {
        if (this.isCancelled) return false;

        if (this.validations) {
          this.showValidations = true;
          if (Object.keys(this.validations).length === 0) {
            await this.addDocuments();
            if (this.addResult) {
              return this.addResult;
            }
          }
        }
      });
    }

    public async addDocuments() {
      this.$loading('Adding document');
      try {
        const successfulUploads: IPackageDocumentRequest[] = [this.updatePackageDocument];
        const helper = new AjaxHelper('/packagedocument/multipledocument', this.verificationToken, null, null);
        const response = await helper.postData<boolean>('',
          { documents: successfulUploads }, { packageType: this.packageType, packageId: this.packageDocumentSetting.packageId });
        this.addResult = response;
      }
      catch (err: any) {
        this.addResult = false;
        this.$alert.error('An error occurred saving document.');
      }
      finally {
        this.$loading();
      }

      return this.addResult;
    }

    public onCancel() {
      this.isCancelled = true;
      this.closeProp();
    }
  }
